import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import FilterRail from './FilterRail';
import MobileDialog, { useMobileDialog } from './MobileDialog';

const Body = ({ filtersData, standaloneFiltersData }) => {
  const { onClose } = useMobileDialog();

  return (
    <Box p={4}>
      <FilterRail
        isFullScreen
        onClose={onClose}
        filtersData={filtersData}
        standaloneFiltersData={standaloneFiltersData}
      />
    </Box>
  );
};

function MobileFilters({ filtersData, standaloneFiltersData, variant = 'sticky' }) {
  return (
    <MobileDialog title="Filter" variant={variant}>
      <Body filtersData={filtersData} standaloneFiltersData={standaloneFiltersData} />
    </MobileDialog>
  );
}

MobileFilters.propTypes = {
  filtersData: PropTypes.array,
  standaloneFiltersData: PropTypes.array,
  variant: PropTypes.string,
};

export default MobileFilters;
